import { GlobalType } from './types/GlobalType';

export const Global: GlobalType = window.fsokConfig || {
  wmsHost: '/geoserver/wms/',
  wfsHost: '/geoserver/wfs/',
  kartstodTyp: 'PREMIUM',
};
